"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeatableContentWithDefaultNestableContentValues = exports.withDefaultNestableContentValues = void 0;
const nestable_1 = require("./nestable");
function withDefaultNestableContentValues(customType, content) {
    return Object.entries(customType).reduce((updatedContent, [widgetKey, widgetDef]) => {
        if (content[widgetKey] === undefined) {
            const defaultValue = (0, nestable_1.NestableContentDefaultValue)(widgetDef);
            return defaultValue !== undefined
                ? {
                    ...updatedContent,
                    [widgetKey]: defaultValue,
                }
                : updatedContent;
        }
        return updatedContent;
    }, content);
}
exports.withDefaultNestableContentValues = withDefaultNestableContentValues;
function repeatableContentWithDefaultNestableContentValues(fields, content) {
    const groupKeys = Object.entries(fields);
    return content.map((contentItem) => {
        return groupKeys.reduce((updatedContentItem, [key, fieldDef]) => {
            if (!contentItem.value.find(([_key]) => _key === key)) {
                const defaultValue = (0, nestable_1.NestableContentDefaultValue)(fieldDef);
                return {
                    ...updatedContentItem,
                    value: [
                        ...updatedContentItem.value,
                        ...(defaultValue ? [[key, defaultValue]] : []),
                    ],
                };
            }
            return updatedContentItem;
        }, contentItem);
    });
}
exports.repeatableContentWithDefaultNestableContentValues = repeatableContentWithDefaultNestableContentValues;
